import { useState } from 'react'
import { isSameDay, startOfDay } from 'date-fns'

import { useTimeZone } from '../../../../../hooks'
import {
  toUkTimezoneDate,
  transposeToLocalTimezoneDate,
  transposeToUkTimezoneDate,
} from '../../../../../utils/date'

export function useDatePickerWithRange({
  endValue,
  initialIsRange,
  startValue,
  value,
}) {
  const timezone = useTimeZone()

  function toCalendarDay(date) {
    return date
      ? startOfDay(transposeToLocalTimezoneDate(date, timezone))
      : null
  }

  function toTzDay(day) {
    return day ? transposeToUkTimezoneDate(startOfDay(day), timezone) : null
  }

  // calendar days
  const calendarSingleValue = toCalendarDay(value)
  const calendarStartValue = toCalendarDay(startValue)
  const calendarEndRaw = toCalendarDay(endValue)

  const isBackendSingleDay =
    !startValue || !endValue
      ? false
      : isSameDay(
          toUkTimezoneDate(startValue, timezone),
          toUkTimezoneDate(endValue, timezone)
        )

  const calendarEndValue = isBackendSingleDay ? null : calendarEndRaw

  // tz days (for inputs / output)
  const inputSingle = toTzDay(calendarSingleValue)
  const inputStart = toTzDay(calendarStartValue)
  const inputEnd = toTzDay(calendarEndRaw)

  // `initialIsRange` opens the picker in range mode before any value exists;
  // the toggle still lets the user drop to a single day.
  const [isRange, setIsRange] = useState(
    Boolean(initialIsRange) || (!!calendarStartValue && !!calendarEndValue)
  )

  const calendarValue = isRange
    ? (calendarEndValue ?? calendarStartValue ?? calendarSingleValue)
    : (calendarSingleValue ?? calendarStartValue)

  const isPickingEnd = isRange && calendarStartValue && !calendarEndValue

  return {
    calendarEndValue,
    calendarSingleValue,
    calendarStartValue,
    calendarValue,
    inputEnd,
    inputSingle,
    inputStart,
    isPickingEnd,
    isRange,
    setIsRange,
    toTz: toTzDay,
  }
}
